/** @property csi/store/ValuePairsFromNodes */
define([
	"dojo/_base/declare",
	"./_ValuesFrom",
	"./ValuePairs"
], function(declare,_ValuesFrom,ValuePairs) {

	return declare(_ValuesFrom, {
		/** @property {Spec} spec1 - specification for first property/attribute to extract values from */
		spec1: null,

		/** @property {Spec} spec2 - specification for second property/attribute to extract values from */
		spec2: null,

		/**
		 * Create ValuePairs store from data
		 * @param {Object[]} data
		 * @param {Object} storeOptions
		 * @return {ValuePairs}
		 */
		_onDataCreateValuesStore: function(data, storeOptions) {
			var store = ValuePairs.createFromNodes(data, storeOptions);
			this.value1Property = store.value1Property;
			this.value2Property = store.value2Property;
			return store;
		}
	});
});